import Vue from 'vue';
import Router from 'vue-router';
import Callback from '@/components/Callback';
import adminRoutes from '@/router/irAdmin';
import investorRoutes from '@/router/investor';
import trackRecentRecord from '@/router/recentRecordsTracker';

Vue.use(Router);

const router = new Router({
  routes: [
    ...investorRoutes,
    ...adminRoutes,
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
    },
  ],
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.afterEach((to) => {
  trackRecentRecord(to);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js